import { Box, Skeleton, Container, Paper } from "@mui/material";

const AdditionalFieldSkeleton = () => {
    return (
        <Box sx={{ display: "flex", height: "100vh" }}>


            <Container maxWidth="md" sx={{ flexGrow: 1, py: 4 }}>

                <Skeleton variant="text" width="80%" height={30} sx={{ mt: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={100} sx={{ mt: 2 }} />

                {/* Form Skeleton */}
                <Skeleton variant="text" width="60%" height={30} sx={{ mt: 3 }} />
                <Skeleton variant="rectangular" width="100%" height={50} sx={{ mt: 1 }} />
                <Skeleton variant="rectangular" width="100%" height={50} sx={{ mt: 1 }} />



            </Container>
        </Box>
    );
};

export default AdditionalFieldSkeleton;
